module.exports = __webpack_public_path__ + "static/media/mobileAboutTile.a23b4441.svg";